export default __webpack_public_path__ + "static/videoBackgroundMobile-14b7bdc015f0c47bac56dc4b4b28e82f.mp4";